import styled from '@mui/material/styles/styled';

export const Root = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
  display: 'flex'
}));

export const UnselectedContainer = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});
